import PropTypes from "prop-types";
import React, { useContext } from "react";

import { classNames } from "@swa-ui/string";

import "../../generated/platforms/scss/helpcenter-dark.module.scss";
import "../../generated/platforms/scss/helpcenter-light.module.scss";
import { DesignTokensThemeContext, DesignTokensThemeProvider } from "../DesignTokensThemeProvider";

/**
 * Theme for SWA Help Center styles.
 */

export const HelpCenterTheme = (props) => {
  const { children } = props;
  const { isDarkMode } = useContext(DesignTokensThemeContext) ?? {};

  return <DesignTokensThemeProvider {...getProps()}>{children}</DesignTokensThemeProvider>;

  function getProps() {
    return {
      className: classNames(
        isDarkMode ? "helpcenter-dark-theme" : "helpcenter-light-theme",
        "helpcenter-theme"
      ),
      inverse: false,
      themeName: "helpcenter",
    };
  }
};

HelpCenterTheme.propTypes = {
  /** Content that will be rendered within the theme. */
  children: PropTypes.node,
};
